module.exports = __webpack_public_path__ + "img/loading-mobile.3821fdbe.svg";